import { ADD_ERROR } from '../../constants/index.js';

/**
 * Create an add error action.
 * 
 * @param   {String} error 
 * @returns {Object}
 */
function addError( error )
{
	return {
		type: ADD_ERROR,
		payload: error
	};
}

/**
 * Export
 */
export { addError };